module.exports = __webpack_public_path__ + "static/img/F-751_2X3.e268b409.webp";